import { Button, Paper, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { fetchSiteContent, sectionOr } from '../../../utils/siteContent';
import BANNER_DEFAULTS from '../../../data/banners.default.json';
import Carousel from 'react-material-ui-carousel';
import './Banner.css'
import { HashLink } from 'react-router-hash-link';

const Banner = () => {

    function Item(props) {
        const { item, priority } = props;
        return (
            <Paper>
                <div className='banner-container'>
                    <img
                        src={item.img}
                        srcSet={item.imgSrcSet}
                        sizes="(max-width: 960px) 100vw, 1600px"
                        width={item.width}
                        height={item.height}
                        loading={priority ? "eager" : "lazy"}
                        decoding="async"
                        fetchPriority={priority ? "high" : "auto"}
                        alt={item.name}
                    />
                    <div className='banner-text tracking-in-expand'>
                        <Typography component="h1" variant="h3">
                            {item.name}
                        </Typography>
                        <Typography component="p">
                            {item.description}
                        </Typography>

                        <HashLink smooth to="/contact" className='text-style'>
                            <Button sx={{ mt: 2 }} variant="contained" className="CheckButton">
                                Visit Today!
                            </Button>
                        </HashLink>
                    </div>
                </div>

            </Paper>
        )
    }
    // Same file the import script reads, so the fallback and what lands in
    // the admin app are guaranteed to match.
    const BUILT_IN = BANNER_DEFAULTS.map((b) => ({
        name: b.title,
        description: b.description,
        img: b.imageUrl,
        imgSrcSet: b.imageUrl.replace('-1600.jpg', '-640.jpg') + ' 640w, '
            + b.imageUrl.replace('-1600.jpg', '-960.jpg') + ' 960w, '
            + b.imageUrl + ' 1600w',
        width: 1600,
        height: 901,
    }));

    // The owner can replace these from the admin app. Until they do — or if the
    // content service is unreachable — the built-in slides above are what
    // renders, so the homepage never comes up blank.
    const [items, setItems] = useState(BUILT_IN);

    useEffect(() => {
        let cancelled = false;
        fetchSiteContent().then((content) => {
            if (cancelled) return;
            const banners = sectionOr(content, 'banners', null);
            if (!banners) return;

            const usable = banners
                .filter((b) => b.imageUrl)
                .map((b) => ({
                    name: b.title || '',
                    description: b.description || '',
                    img: b.imageUrl,
                    // Cloudinary resizes on the fly, so the responsive set is
                    // derived from the one uploaded image rather than needing
                    // three files cut by hand.
                    imgSrcSet: [640, 960, 1600]
                        .map((w) => `${b.imageUrl.replace('/upload/', `/upload/w_${w},c_limit,q_auto,f_auto/`)} ${w}w`)
                        .join(', '),
                    width: 1600,
                    height: 901,
                }));

            if (usable.length > 0) setItems(usable);
        });
        return () => { cancelled = true; };
    }, []);

    return (
        <div>
            <Carousel>
                {
                    items.map((item, i) => <Item key={i} item={item} priority={i === 0} />)
                }
            </Carousel>
        </div>
    );
};

export default Banner;
